
import { useState, useEffect } from "react";
import { useRevealAnimation } from "@/hooks/use-reveal-animation";
import { useIsMobile } from "@/hooks/use-mobile";

interface ProductImagesProps {
  images: string[];
  productName: string;
}

const ProductImages = ({ images, productName }: ProductImagesProps) => {
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const isMobile = useIsMobile();
  const { ref, isVisible } = useRevealAnimation<HTMLDivElement>();
  
  // Add fade-in effect on initial load
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div 
      className="space-y-4"
      ref={ref}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'all 0.7s ease-out',
      }}
    >
      <div 
        className="aspect-square rounded-lg overflow-hidden bg-white shadow-md"
        style={{
          opacity: isLoaded ? 1 : 0,
          transition: 'opacity 0.5s ease-out',
        }}
      >
        <img
          src={images[activeImageIndex]}
          alt={productName}
          className="w-full h-full object-cover"
          loading="eager" // Main product image loads eagerly
        />
      </div>
      <div className="flex gap-2 md:gap-4 overflow-auto pb-2 no-scrollbar">
        {images.map((image, index) => (
          <button
            key={index}
            onClick={() => setActiveImageIndex(index)}
            className={`w-16 h-16 md:w-20 md:h-20 rounded-md overflow-hidden flex-shrink-0 border-2 transition-all duration-300 ${
              activeImageIndex === index ? "border-primary scale-105" : "border-transparent"
            }`}
            style={{
              opacity: isLoaded ? 1 : 0,
              transform: isLoaded ? 'translateY(0)' : 'translateY(10px)',
              transition: `all 0.5s ease-out ${index * 0.1}s`,
            }}
          >
            <img 
              src={image} 
              alt={`${productName} view ${index + 1}`} 
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProductImages;
